webpackJsonp([82],{

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _RDForm = __webpack_require__(848);

var _RDForm2 = _interopRequireDefault(_RDForm);

__webpack_require__(655);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KitClientesInativos = function (_React$Component) {
    _inherits(KitClientesInativos, _React$Component);

    function KitClientesInativos() {
        _classCallCheck(this, KitClientesInativos);

        return _possibleConstructorReturn(this, (KitClientesInativos.__proto__ || Object.getPrototypeOf(KitClientesInativos)).apply(this, arguments));
    }

    _createClass(KitClientesInativos, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.headData && _react2.default.createElement(
                    _reactStatic.Head,
                    null,
                    _react2.default.createElement(
                        'title',
                        null,
                        this.props.headData.pageTitle
                    ),
                    _react2.default.createElement('meta', { property: 'og:title', content: this.props.headData.pageTitle }),
                    _react2.default.createElement('meta', { name: 'twitter:title', content: this.props.headData.pageTitle }),
                    _react2.default.createElement('meta', { name: 'description', content: this.props.headData.pageDescription }),
                    _react2.default.createElement('meta', { property: 'og:description', content: this.props.headData.pageDescription }),
                    _react2.default.createElement('meta', { name: 'twitter:description', content: this.props.headData.pageDescription }),
                    _react2.default.createElement('meta', { property: 'og:image', content: this.props.headData.ogImage }),
                    _react2.default.createElement('meta', { name: 'twitter:image', content: this.props.headData.ogImage }),
                    _react2.default.createElement('meta', { property: 'og:url', content: this.props.headData.ogUrl }),
                    _react2.default.createElement('link', { rel: 'canonical', href: this.props.headData.ogUrl })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'kit-clientes-inativos' },
                    _react2.default.createElement(
                        'div',
                        { className: 'hero' },
                        _react2.default.createElement(
                            'div',
                            { className: 'container' },
                            _react2.default.createElement(
                                'div',
                                { className: 'left-column' },
                                _react2.default.createElement('img', { src: '/images/logo_mercos_footer.png', alt: 'Logomarca Mercos', className: 'logo' }),
                                _react2.default.createElement(
                                    'h1',
                                    { className: 'large-title' },
                                    'Calcule quanto dinheiro ',
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        '"tem na mesa"'
                                    ),
                                    ' no seu neg\xF3cio'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    { className: 'paragraph' },
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        'Voc\xEA quer aumentar seus resultados, mas n\xE3o sabe como?'
                                    ),
                                    ' Com certeza, tem oportunidades "na palma da m\xE3o" que n\xE3o est\xE3o sendo observadas. Descubra o quanto voc\xEA pode ganhar a mais e como fazer isso!'
                                ),
                                _react2.default.createElement('img', { src: '/images/site/landing-pages/kit-clientes-inativos/bill-coins.png', alt: 'Notas e moedas', className: 'bill-coins' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'right-column' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'form-title' },
                                    'Preencha o formul\xE1rio abaixo'
                                ),
                                _react2.default.createElement(
                                    _RDForm2.default,
                                    { kitClientes: true, buttonText: 'Acesar Material' },
                                    'Acesar Material '
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'section',
                        { className: 'container centered' },
                        _react2.default.createElement(
                            'h2',
                            { className: 'big-title' },
                            'Neste ',
                            _react2.default.createElement(
                                'b',
                                null,
                                'kit gratuito'
                            ),
                            ' voc\xEA vai ver:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'box-list-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'box-list' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'icon' },
                                    _react2.default.createElement('img', { src: '/images/site/landing-pages/b2b-rep/dot.svg', alt: '' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'box-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'box-title' },
                                        'Calculadora de Oportunidades'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'box-text' },
                                        'Calcule o quanto de receita pode receber a mais trabalhando a sua base de clientes e receba um diagn\xF3stico das oportunidades na sua opera\xE7\xE3o comercial.'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'box-list' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'icon' },
                                    _react2.default.createElement('img', { src: '/images/site/landing-pages/b2b-rep/dot.svg', alt: '' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'box-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'box-title' },
                                        'E-book "Estrat\xE9gias de Receita"'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'box-text' },
                                        'Um passo a passo de como identificar os dados relevantes para a an\xE1lise de oportunidades de neg\xF3cios, al\xE9m de estrat\xE9gias pr\xE1ticas para melhorar estes n\xFAmeros.'
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return KitClientesInativos;
}(_react2.default.Component);

exports.default = (0, _reactStatic.withRouteData)(function (props) {
    return _react2.default.createElement(KitClientesInativos, props);
});

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(563);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(554);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Component) {
    _inherits(Link, _Component);

    function Link(props) {
        _classCallCheck(this, Link);

        var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

        _this.state = {
            isActive: false
        };
        return _this;
    }

    _createClass(Link, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                isActive: window.location.href === window.location.pathname + window.location.hash ? 'active' : false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'a',
                { className: (0, _classnames2.default)('link', this.props.arrow && 'arrow', this.props.className, this.props.color, this.props.model, this.props.weight, this.state.isActive),
                    href: !this.state.isActive ? this.props.href : undefined,
                    onClick: this.props.onClick,
                    onMouseOver: this.props.onMouseOver,
                    target: this.props.target,
                    title: this.props.title,
                    rel: this.props.rel ? this.props.rel : this.props.target === '_blank' ? 'noopener noreferrer' : '',
                    ref: this.props.linkRef },
                this.props.children
            );
        }
    }]);

    return Link;
}(_react.Component);

Link.defaultProps = {
    color: 'linkDark',
    model: 'initial-underline',
    weight: 'medium'
};

Link.propTypes = {
    color: _propTypes2.default.oneOf(['linkDark', 'linkLight', 'green', 'white', 'linkBlack']),
    model: _propTypes2.default.oneOf(['initial-underline', 'hover-underline']),
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    weight: _propTypes2.default.oneOf(['thin', 'extra-light', 'light', 'regular', 'medium', 'semi-bold', 'bold', 'extra-bold', 'black'])
};

exports.default = Link;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(38);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = __webpack_require__(553);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RDGateway = function () {
  function RDGateway() {
    _classCallCheck(this, RDGateway);
  }

  _createClass(RDGateway, [{
    key: "sendToRDStation",
    value: function sendToRDStation(data, redirectLink) {
      var _this = this;

      var dataCookies = {
        cf_origem: _jsCookie2.default.get("mutm_source") || "",
        cf_midia: _jsCookie2.default.get("mutm_medium") || "",
        cf_campanha: _jsCookie2.default.get("mutm_campaign") || "",
        cf_utm_term: _jsCookie2.default.get("mutm_term") || "",
        cf_utm_content: _jsCookie2.default.get("mutm_content") || "",
        cf_fbclid: _jsCookie2.default.get("mfbclid") || "",
        cf_glcid: _jsCookie2.default.get("mgclid") || "",
        cf_wbraid: _jsCookie2.default.get("mwbraid") || "",
        cf_gbraid: _jsCookie2.default.get("mgbraid") || "",
        website: "Mercos",
        cf_page_url: window.location.origin + window.location.pathname,
        cf_page_title: document.title,
        cf_ga4_client_id: _jsCookie2.default.get("_ga") || "",
        cf_ga4_muser_id: _jsCookie2.default.get("MUserID") || ""
      };

      this.hashEmail(data.email).then(function (hashedEmail) {
        var enrichedData = _extends({}, dataCookies, data, { cf_email_hash: hashedEmail });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(enrichedData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            enrichedData[key] = String(value);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.sendDataLayer(enrichedData);

        Promise.all([_this.sendToRD(enrichedData), _this.sendToHubspot(enrichedData)]).then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              responseRD = _ref4[0],
              responseHubspot = _ref4[1];

          if (responseRD || responseHubspot) {
            if (redirectLink) {
              window.location = redirectLink;
            }
          } else {
            //alert("Ooops! Tivemos um pequeno problema no recebimento do formulário. Por favor, tente novamente.")
          }
        });
      });
    }
  }, {
    key: "sendDataLayer",
    value: function sendDataLayer(enrichedData) {
      try {
        window.dataLayer = window.dataLayer || [];
        var dataLayerObject = {
          event: "event_track",
          event_category: "form_submit",
          event_action: enrichedData.event_action || "",
          event_label: (enrichedData.event_label || "").replace(/-/g, "_"),
          MUserId: "",
          emailHash: enrichedData.cf_email_hash || "",
          email: enrichedData.email || "",
          codigo_parceiro: enrichedData.cf_codigo_do_parceiro_meus_pedidos || ""
        };

        if (this.getCompanyType(enrichedData)) {
          dataLayerObject.event_companyType = this.getCompanyType(enrichedData);
        }

        dataLayer.push(dataLayerObject);
        return true;
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: "gaexpDataSplit",
    value: function gaexpDataSplit(data) {
      try {
        var arr = data.split(".");
        var value = "";
        return value.concat(arr[2], ".", arr[4]);
      } catch (error) {
        return "";
      }
    }
  }, {
    key: "hashEmail",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(email) {
        var encoder, emailBytes, hashBytes, hashArray, hashHex;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                encoder = new TextEncoder();
                emailBytes = encoder.encode(email.toLowerCase());
                _context.next = 5;
                return crypto.subtle.digest("SHA-256", emailBytes);

              case 5:
                hashBytes = _context.sent;
                hashArray = Array.from(new Uint8Array(hashBytes));
                hashHex = hashArray.map(function (bytes) {
                  return bytes.toString(16).padStart(2, "0");
                }).join("");
                return _context.abrupt("return", hashHex.slice(0, 36));

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", "");

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function hashEmail(_x) {
        return _ref5.apply(this, arguments);
      }

      return hashEmail;
    }()
  }, {
    key: "getCompanyType",
    value: function getCompanyType(type) {
      if (type && type.cf_atividade_da_empresa) {
        if (type.cf_atividade_da_empresa === "Representante comercial" || type.cf_atividade_da_empresa === "Representação Comercial") {
          return "representacao_comercial";
        } else if (type.cf_atividade_da_empresa === "Distribuição") {
          return "distribuicao";
        } else if (type.cf_atividade_da_empresa === "Indústria") {
          return "industria";
        } else if (type.cf_atividade_da_empresa === "Outra" || type.cf_atividade_da_empresa === "Outro") {
          return "outro";
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }, {
    key: "sendToRD",
    value: function sendToRD(enrichedData) {
      var data = JSON.stringify({
        event_type: "CONVERSION",
        event_family: "CDP",
        payload: enrichedData
      });

      return fetch("https://api.rd.services/platform/conversions?api_key=abSCjrNCSWZvTKmxPEuGiTMxdFFtMlJbyBqX", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer"
        },
        body: data
      }).then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      }).catch(function (error) {
        console.log(error);
        return false;
      });
    }
  }, {
    key: "sendToHubspot",
    value: function sendToHubspot(enrichedData) {
      var _hsq = window._hsq = window._hsq || [];
      _hsq.push(["identify", {
        conversion_identifier: enrichedData.conversion_identifier || "",
        company: enrichedData.company_name || "",
        nome: enrichedData.name || "",
        email: enrichedData.email || "",
        telefone: enrichedData.personal_phone || "",
        time: enrichedData.cf_time || "",
        atividade_da_empresa: enrichedData["cf_atividade_da_empresa"] || "",
        numero_de_vendedores: enrichedData["cf_numero_de_vendedores"] || ""
      }]);

      var hubspotForm = {
        fields: [{
          objectTypeId: "0-1",
          name: "email",
          value: enrichedData.email || ""
        }, {
          objectTypeId: "0-1",
          name: "firstname",
          value: enrichedData.name || ""
        }, {
          objectTypeId: "0-1",
          name: "identificador",
          value: enrichedData.conversion_identifier || ""
        }, {
          objectTypeId: "0-1",
          name: "company",
          value: enrichedData.company_name || ""
        }, {
          objectTypeId: "0-1",
          name: "phone",
          value: enrichedData.personal_phone || ""
        }, {
          objectTypeId: "0-1",
          name: "time",
          value: enrichedData.cf_time || ""
        }, {
          objectTypeId: "0-1",
          name: "atividade_da_empresa",
          value: enrichedData["cf_atividade_da_empresa"] || ""
        }, {
          objectTypeId: "0-1",
          name: "numero_de_vendedores",
          value: enrichedData["cf_numero_de_vendedores"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_origem",
          value: enrichedData["cf_origem"] || ""
        }, {
          objectTypeId: "0-1",
          name: "midia",
          value: enrichedData["cf_midia"] || ""
        }, {
          objectTypeId: "0-1",
          name: "campanha",
          value: enrichedData["cf_campanha"] || ""
        }, {
          objectTypeId: "0-1",
          name: "termo",
          value: enrichedData["cf_utm_term"] || ""
        }, {
          objectTypeId: "0-1",
          name: "conteudo",
          value: enrichedData["cf_utm_content"] || ""
        }, {
          objectTypeId: "0-1",
          name: "fbclid",
          value: enrichedData["cf_fbclid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "gclid",
          value: enrichedData["cf_glcid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_wbraid",
          value: enrichedData["cf_wbraid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "gbraid",
          value: enrichedData["cf_gbraid"] || ""
        }, {
          objectTypeId: "0-1",
          name: "tipo_de_conversao",
          value: enrichedData["cf_tipo_de_conversao"] || ""
        }, {
          objectTypeId: "0-1",
          name: "codigo_do_parceiro_meus_pedidos",
          value: enrichedData["cf_codigo_do_parceiro_meus_pedidos"] || ""
        }, {
          objectTypeId: "0-1",
          name: "city",
          value: enrichedData["city"] || ""
        }, {
          objectTypeId: "0-1",
          name: "erp_utilizado",
          value: enrichedData["cf_erp_utilizado"] || ""
        }, {
          objectTypeId: "0-1",
          name: "descricao_da_necessidade",
          value: enrichedData["cf_descricao_da_necessidade"] || ""
        }, {
          objectTypeId: "0-1",
          name: "carteira_clientes_canais",
          value: enrichedData["cf_carteira_clientes_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "nome_do_parceiro__canais1_",
          value: enrichedData["cf_nome_do_parceiro_canais1"] || ""
        }, {
          objectTypeId: "0-1",
          name: "clientes_ativos__canais_",
          value: enrichedData["cf_clientes_ativos_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "ramo_de_atuacao__canais_",
          value: enrichedData["cf_ramo_de_atuacao_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "percentual_perfil_ind_dist__canais_",
          value: enrichedData["cf_percentual_perfil_ind_dist_canais"] || ""
        }, {
          objectTypeId: "0-1",
          name: "observacoes",
          value: enrichedData["cf_observacoes"] || ""
        }, {
          objectTypeId: "0-1",
          name: "unidade_de_negocio_salesforce",
          value: enrichedData["cf_unidade_de_negocio_salesforce"] || ""
        }, {
          objectTypeId: "0-1",
          name: "site",
          value: enrichedData["website"] || ""
        }, {
          objectTypeId: "0-1",
          name: "cf_isoptimizetest",
          value: enrichedData["cf_isoptimizetest"] || ""
        }, {
          objectTypeId: "0-1",
          name: "empresa",
          value: enrichedData.company_name || ""
        }, {
          objectTypeId: "0-1",
          name: "telefone",
          value: enrichedData.personal_phone || ""
        }, {
          objectTypeId: "0-1",
          name: "email_hash",
          value: enrichedData.cf_email_hash || ""
        }],
        context: {
          pageUri: window.location.origin + window.location.pathname,
          pageName: document.title
        }
      };

      return fetch("https://api.hsforms.com/submissions/v3/integration/submit/21596284/632b7e2d-915b-4384-86eb-678c7bb78e4a", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(hubspotForm)
      }).then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return false;
        }
      }).catch(function (error) {
        console.log(error);
        return false;
      });
    }
  }]);

  return RDGateway;
}();

exports.default = RDGateway;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(571);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(573);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(563);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = function ButtonLink(_ref) {
    var children = _ref.children,
        color = _ref.color,
        model = _ref.model,
        size = _ref.size,
        radius = _ref.radius,
        className = _ref.className,
        _ref$href = _ref.href,
        href = _ref$href === undefined ? '/' : _ref$href,
        target = _ref.target,
        rel = _ref.rel,
        title = _ref.title,
        onClick = _ref.onClick,
        style = _ref.style,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        shake = _ref.shake;
    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('button', model, size, radius, className, color, shake && 'shake'),
            href: href,
            target: target,
            title: title,
            onClick: onClick,
            style: style,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            rel: rel ? rel : target === '_blank' ? 'noopener noreferrer' : '' },
        children
    );
};

ButtonLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.any,
    color: _propTypes2.default.string,
    href: _propTypes2.default.string,
    model: _propTypes2.default.oneOf(['outline', 'secondary', 'success', 'alert', 'warning']),
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded']),
    size: _propTypes2.default.string,
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    title: _propTypes2.default.string
};

exports.default = ButtonLink;

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(574);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
        'aria-label': ariaLabel,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        onChange: onChange,
        placeholder: placeholder,
        type: type,
        value: value,
        name: name || id
    });
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var telephoneMask = exports.telephoneMask = function telephoneMask(value) {
    var cleanTelephone = value ? value.replace(/\D/g, "") : '';
    var numberLength = cleanTelephone.length;

    if (numberLength > 10) {
        cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
    } else if (numberLength > 6 && numberLength < 11) {
        cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
    }

    if (numberLength > 2) {
        cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
    }

    if (numberLength > 0) {
        cleanTelephone = '(' + cleanTelephone.slice(0);
    }

    return cleanTelephone;
};

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(554);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading4 = function Heading4(_ref) {
    var children = _ref.children,
        center = _ref.center,
        white = _ref.white,
        gray = _ref.gray,
        bottomSpace = _ref.bottomSpace,
        className = _ref.className;
    return _react2.default.createElement(
        'h4',
        { className: (0, _classnames2.default)('heading4', className, center ? 'text-center' : '', white ? 'heading-white' : '', gray ? 'heading-gray' : '', bottomSpace ? 'bottom-space' : '') },
        children
    );
};

exports.default = Heading4;

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(552);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(572);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(553);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(555);

var _Button2 = _interopRequireDefault(_Button);

var _ButtonLink = __webpack_require__(565);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _Link = __webpack_require__(557);

var _Link2 = _interopRequireDefault(_Link);

var _Modal = __webpack_require__(560);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(566);

var _Input2 = _interopRequireDefault(_Input);

var _Heading = __webpack_require__(570);

var _Heading2 = _interopRequireDefault(_Heading);

var _RDGateway = __webpack_require__(558);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var RDForm = function (_Component) {
    _inherits(RDForm, _Component);

    function RDForm(props) {
        _classCallCheck(this, RDForm);

        var _this = _possibleConstructorReturn(this, (RDForm.__proto__ || Object.getPrototypeOf(RDForm)).call(this, props));

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        return _this;
    }

    _createClass(RDForm, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                name: '',
                email: '',
                telephone: '',
                activity: '',
                typingTimeout: 0,
                partnerId: props.partnerId
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var name = e.target.id;
            var value = e.target.value;

            if (name === 'telephone') {
                value = (0, _masks.telephoneMask)(value);
            } else if (name === 'name') {} else if (name === 'email') {} else if (name === 'activity') {}

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (name === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'handlerEnterpriseActivitySelect',
        value: function handlerEnterpriseActivitySelect(e) {
            this.setState({ selectValue: e.target.value });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            FIELDS.forEach(function (campo) {
                if (!_this3.props.kitClientes) {
                    newState[campo + 'Error'] = !_this3.state[campo];
                }

                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            if (_this3.props.kitClientes) {
                                break;
                            }
                            newState[campo + 'Error'] = !regexTelephone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();

            if (this.validation()) {
                var data = {
                    conversion_identifier: this.props.kitClientes ? 'kit-clientes-inativos' : 'inscreveu-imersao-vendas-atacado',
                    'cf_tipo_de_conversao': this.props.kitClientes ? 'Acessou o kit de clientes inativos' : 'Inscreveu na Imersão em Vendas para o Atacado',
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: this.props.kitClientes ? 'download' : '',
                    event_label: this.props.kitClientes ? 'kit-clientes-inativos' : ''
                };

                var redirectLink = this.props.kitClientes ? '/materiais/tp-kit-clientes-inativos' : 'https://mercos.com/tp/tp-imersao-vendas-atacado/';

                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();

            var handler = function handler() {
                var visible = document.documentElement.scrollTop >= window.innerHeight - 200;
                if (visible) {
                    document.getElementById("root").classList.add("show-bt-fixo");
                } else document.getElementById("root").classList.remove("show-bt-fixo");
            };
            globalThis.addEventListener("load", handler);
            globalThis.addEventListener("resize", handler);
            globalThis.addEventListener("scroll", handler);
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this4 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this4.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'container-form-modal' },
                    _react2.default.createElement(
                        _Heading2.default,
                        { className: 'form-title' },
                        'Garanta a sua vaga! Preencha o formul\xE1rio para realizar sua inscri\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                                return _this4.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.nameError, autoFocus: true, placeholder: 'Seu Nome' }),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'Email' }),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this4.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'label',
                            { style: { marginTop: '20px' } },
                            'Qual \xE9 a atividade da sua empresa?'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'group-buttons' },
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.industria);
                                    } },
                                'Ind\xFAstria'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                                    } },
                                'Distribui\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.rep);
                                    } },
                                'Representante comercial'
                            ),
                            _react2.default.createElement(
                                _Button2.default,
                                { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                        return _this4.handlerEnterpriseActivity(ACTIVITY.outra);
                                    } },
                                'Outra'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', radius: this.props.radius, className: this.props.className },
                                'Inscreva-se Gratuitamente'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'desktopFullForm',
        value: function desktopFullForm() {
            var _this5 = this;

            return _react2.default.createElement(
                'div',
                { className: 'container-form-desktop' },
                _react2.default.createElement(
                    'form',
                    { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                            return _this5.submitForm(e);
                        } },
                    _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                            return _this5.handleChange(e);
                        }, error: this.state.nameError, autoFocus: true, placeholder: 'Seu Nome' }),
                    _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                            return _this5.handleChange(e);
                        }, error: this.state.emailError, placeholder: 'Email' }),
                    _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                            return _this5.handleChange(e);
                        }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                    _react2.default.createElement(
                        'label',
                        { style: { marginTop: '20px' } },
                        'Qual \xE9 a atividade da sua empresa?'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'group-buttons' },
                        _react2.default.createElement(
                            _Button2.default,
                            { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                    return _this5.handlerEnterpriseActivity(ACTIVITY.industria);
                                } },
                            'Ind\xFAstria'
                        ),
                        _react2.default.createElement(
                            _Button2.default,
                            { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                    return _this5.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                                } },
                            'Distribui\xE7\xE3o'
                        ),
                        _react2.default.createElement(
                            _Button2.default,
                            { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                    return _this5.handlerEnterpriseActivity(ACTIVITY.rep);
                                } },
                            'Representante comercial'
                        ),
                        _react2.default.createElement(
                            _Button2.default,
                            { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                    return _this5.handlerEnterpriseActivity(ACTIVITY.outra);
                                } },
                            'Outra'
                        ),
                        this.state.activityError ? _react2.default.createElement(
                            'div',
                            { style: { color: 'red' } },
                            'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                        ) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'submit-demo-modal' },
                        _react2.default.createElement(
                            _Button2.default,
                            { type: 'submit', radius: this.props.radius, className: this.props.className },
                            this.props.buttonText ? this.props.buttonText : 'Inscreva-se Gratuitamente'
                        )
                    )
                )
            );
        }
    }, {
        key: 'kitClientesForm',
        value: function kitClientesForm() {
            var _this6 = this;

            return _react2.default.createElement(
                'div',
                { className: 'container-form-desktop' },
                _react2.default.createElement(
                    'form',
                    { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                            return _this6.submitForm(e);
                        } },
                    _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                            return _this6.handleChange(e);
                        }, error: this.state.nameError, autoFocus: true, placeholder: 'Seu Nome' }),
                    _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                            return _this6.handleChange(e);
                        }, error: this.state.emailError, placeholder: 'Email' }),
                    _react2.default.createElement(
                        'label',
                        { style: { marginTop: '20px' } },
                        'Qual \xE9 a atividade da sua empresa?'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'group-buttons' },
                        _react2.default.createElement(
                            _Button2.default,
                            { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                    return _this6.handlerEnterpriseActivity(ACTIVITY.industria);
                                } },
                            'Ind\xFAstria'
                        ),
                        _react2.default.createElement(
                            _Button2.default,
                            { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                    return _this6.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                                } },
                            'Distribui\xE7\xE3o'
                        ),
                        _react2.default.createElement(
                            _Button2.default,
                            { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                    return _this6.handlerEnterpriseActivity(ACTIVITY.rep);
                                } },
                            'Representante comercial'
                        ),
                        _react2.default.createElement(
                            _Button2.default,
                            { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                    return _this6.handlerEnterpriseActivity(ACTIVITY.outra);
                                } },
                            'Outra'
                        ),
                        this.state.activityError ? _react2.default.createElement(
                            'div',
                            { style: { color: 'red' } },
                            'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                        ) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'submit-demo-modal' },
                        _react2.default.createElement(
                            _Button2.default,
                            { type: 'submit', radius: this.props.radius, className: this.props.className },
                            this.props.buttonText ? this.props.buttonText : 'Inscreva-se Gratuitamente'
                        )
                    )
                )
            );
        }
    }, {
        key: 'desktopForm',
        value: function desktopForm() {
            var _this7 = this;

            return _react2.default.createElement(
                'div',
                { className: 'container-form-desktop' },
                _react2.default.createElement(
                    'form',
                    { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                            return _this7.submitForm(e);
                        } },
                    _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                            return _this7.handleChange(e);
                        }, error: this.state.nameError, autoFocus: true, placeholder: 'Seu Nome' }),
                    _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                            return _this7.handleChange(e);
                        }, error: this.state.emailError, placeholder: 'Email' }),
                    _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                            return _this7.handleChange(e);
                        }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                    _react2.default.createElement(
                        'select',
                        { className: 'input all-rounded', name: 'activity', id: 'activity', value: this.state.selectValue, onChange: function onChange(e) {
                                return _this7.handleChange(e);
                            } },
                        _react2.default.createElement(
                            'option',
                            { value: '' },
                            'Qual \xE9 a atividade da sua empresa?'
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: 'industria' },
                            'Ind\xFAstria'
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: 'distribuicao' },
                            'Distribui\xE7\xE3o'
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: 'rep' },
                            'Representante comercial'
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: 'outra' },
                            'Outra'
                        )
                    ),
                    this.state.activityError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'submit-demo-modal' },
                        _react2.default.createElement(
                            _Button2.default,
                            { type: 'submit', radius: this.props.radius, className: this.props.className },
                            'Inscreva-se Gratuitamente'
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this8 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.desktopModal ? this.desktopForm() : '',
                this.props.desktopFull ? this.desktopFullForm() : '',
                this.props.kitClientes ? this.kitClientesForm() : '',
                this.props.isLink ? _react2.default.createElement(
                    _react.Fragment,
                    null,
                    _react2.default.createElement(
                        _Link2.default,
                        {
                            href: '.',
                            color: this.props.color,
                            className: this.props.className,
                            onClick: function onClick(e) {
                                return _this8.openDemoModal(e);
                            },
                            title: 'Inscreva-se Gratuitamente'
                        },
                        this.props.b2b ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            'E-commerce B2B ',
                            _react2.default.createElement('br', null),
                            'opcional, com pre\xE7o sob consulta.'
                        ) : _react2.default.createElement(
                            'span',
                            { style: { whiteSpace: 'nowrap' } },
                            'pe\xE7a uma demonstra\xE7\xE3o'
                        )
                    ),
                    this.state.showDemoModal && this.getDemoModal()
                ) : _react2.default.createElement(
                    'div',
                    { className: 'fixed-bt' },
                    _react2.default.createElement(
                        _ButtonLink2.default,
                        {
                            href: '.',
                            className: "button-display-modal-rd " + (this.props.className ? this.props.className : ''),
                            onClick: function onClick(e) {
                                return _this8.openDemoModal(e);
                            },
                            title: 'Inscreva-se.',
                            radius: this.props.radius
                        },
                        this.props.children || 'Inscreva-se Gratuitamente'
                    )
                ),
                this.state.showDemoModal && this.getDemoModal()
            );
        }
    }]);

    return RDForm;
}(_react.Component);

RDForm.propTypes = {
    b2b: _propTypes2.default.bool,
    contaAzul: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    radius: _propTypes2.default.string,
    partnerId: _propTypes2.default.string
};
RDForm.defaultProps = {
    b2b: false,
    contaAzul: false,
    radius: 'half-rounded'
};
exports.default = RDForm;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/site/landing-pages/kitclientesinativos/KitClientesInativos.jsx.3985b23d.js